import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import noty from "../../lib/noty";
import Field from "../Field";

export default class GroupModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      fetching: false,
      touched: false,
      group: this.props.group
    };
  }

  handleClose = () => {
    if (this.state.touched) {
      noty.confirm(`Are you sure you want to leave? You have unsaved changes.`, {
        onOk: () => this.props.onRequestClose()
      });
    } else {
      this.props.onRequestClose();
    }
  };

  handleSave = () => {
    const {group} = this.state;
    const method = group._id ? "patch" : "create";
    this.setState({fetching: true});
    group[method]()
      .then(() => {
        method === "patch" ? noty.success("Group updated.") : noty.success("Group created.");
        this.props.onRequestClose();
      })
      .catch(err => {
        noty.errors(err);
        this.setState({fetching: false});
      });
  };

  handleDelete = () => {
    noty.confirm(`Are you sure you want to delete this group?`, {
      onOk: () => {
        this.setState({fetching: true});
        this.state.group
          .remove()
          .then(() => {
            noty.success("Group deleted.");
            this.props.onRequestClose();
          })
          .catch(err => {
            noty.errors(err);
            this.setState({fetching: false});
          });
      }
    });
  };

  promptDelete = () => {
    noty.confirm(
      `You cannot delete this group because there are users associated with
      it. Remove all users from the "${this.state.group.name}" group before deleting.`,
      {onOk: () => {}, alert: true}
    );
  };

  handleChange = ({name, value}) => {
    const path = name.split(".");
    this.setState({
      touched: true,
      group: this.state.group.setIn(path, value)
    });
  };

  render() {
    const {fetching, group} = this.state;

    return (
      <div>
        <Dialog open maxWidth="sm" fullWidth>
          <DialogTitle>Group</DialogTitle>
          <DialogContent>
            <Field name="name" value={group.name} onChange={this.handleChange} label="Group Name" disabled={fetching} />
          </DialogContent>
          <DialogActions>
            <Button color="primary" disabled={fetching} onClick={this.handleClose}>
              Cancel
            </Button>
            <Button color="primary" disabled={fetching} onClick={this.handleSave}>
              Save
            </Button>
            {group._id ? (
              <Button
                onClick={!this.props.totalCount ? this.handleDelete : this.promptDelete}
                style={{float: "left", color: "#999"}}
                disabled={fetching}>
                Delete
              </Button>
            ) : null}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

GroupModal.propTypes = {
  group: PropTypes.object.isRequired,
  totalCount: PropTypes.number,
  onRequestClose: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/GroupModal/index.jsx